<template>
  <v-container class="booking-confirm p-0" v-if="invoice">
    <HkiaraceBannerFrame :src="require('@/assets/acc.jpg')"
                         :label="$t('invoice.summary')">
      <v-container class="booking-confirm-content" fluid>
        <v-row v-if="paymentRecord && paymentRecord.payment_method === 'cyber_source'">
          <v-col cols="12" md="6">
            <v-text-field :label="$t('invoice.payment_reference_no')"
                          readonly
                          hide-details
                          :value="$getPaymentRecordRefNo(paymentRecord)"></v-text-field>
          </v-col>
        </v-row>

        <v-text-field readonly
                      hide-details
                      :label="$t('admin_acc_invoice.invoice_no')"
                      :value="`PO${invoice.purchase_order.id.toString().padStart(8, '0')}/${invoice.invoice_no}`"></v-text-field>
        <v-text-field readonly
                      hide-details
                      :label="$t('admin_acc_invoice.issued_at')"
                      :value="$parseDate(invoice.issued_at, 'yyyy-MM-dd')"></v-text-field>
        <v-text-field readonly
                      hide-details
                      :label="$t('admin_acc_invoice.due_at')"
                      :value="$parseDate(invoice.due_at, 'yyyy-MM-dd')"></v-text-field>
        <v-text-field readonly
                      hide-details
                      :label="$t('admin_acc_invoice.title')"
                      :value="invoice.title"></v-text-field>
        <v-text-field readonly
                      hide-details
                      :label="$t('admin_acc_invoice.amount')"
                      :value="parseInt(invoice.amount) / 100.0"></v-text-field>
        <v-text-field readonly
                      hide-details
                      :label="$t('admin_acc_invoice.status')"
                      :value="$t(`invoice_status.${invoice.status}`)"></v-text-field>
        <v-text-field readonly
                      hide-details
                      :label="$t('admin_acc_invoice.payment_method')"
                      :value="$t(`payment_method.${invoice.payment_method}`)"></v-text-field>

        <v-row>
          <v-col cols="12"
                 md="4">
            <a :href="`${HOST}static/${invoice.pdf}`" target="_blank">
              <v-btn color="primary">
                {{ $t('invoice.download_pdf') }}
              </v-btn>
            </a>
          </v-col>
          <v-col cols="12"
                 md="4">
            <a :href="`${HOST}static/${invoice.receipt}`" target="_blank">
              <v-btn color="primary">
                {{ $t('invoice.download_receipt') }}
              </v-btn>
            </a>
          </v-col>
          <v-col cols="12"
                 md="4">
            <v-btn color="primary"
                   :to="{name: 'my-account', query: {t: 6}}">
              {{ $t('finish') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </HkiaraceBannerFrame>
  </v-container>
</template>

<script>
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
import {onMounted, ref} from "@vue/composition-api";
import {HOST} from "@/main";

export default {
  name: 'InvoicePaySuccess',
  components: {HkiaraceBannerFrame},
  setup(props, {root}) {
    const paymentRecord = ref(null);
    const invoice = ref(null);
    const getPaymentRecord = function () {
      root.$callAPI('aafb/invoice/payment_record/', {invoice_id: root.$route.params.invoiceId}, (response) => {
        paymentRecord.value = response.body.record;
        invoice.value = response.body.invoice;
      })
    }

    const next = function () {
      root.$router.push({name: 'my-account', query: {t: 6}})
    }

    onMounted(() => {
      getPaymentRecord();
    });

    return {
      paymentRecord,
      invoice,
      next,

      HOST,
    }
  },
}
</script>

<style lang="less">
.booking-confirm {
  .booking-confirm-content {
    max-width: 1000px;
    background-color: white;
    padding: 2rem;

    .booking-confirm-title {
      color: #8E765B;
      font-size: 1.5em !important;
    }

    .v-label {
      color: #8E765B;
    }

    .v-text-field > .v-input__control > .v-input__slot:before {
      display: none;
    }

    .v-text-field > .v-input__control > .v-input__slot:after {
      display: none;
    }
  }

  .fa-check-circle {
    font-size: 5em;
  }

  @media (min-width: 992px) {
    font-size: 1.2em;

    .confirm-message-label {
      font-size: 2em !important;
    }

    .booking-summary-title {
      font-size: 2.5em !important;
    }
  }

  .confirm-message-label {
    font-size: 1.5em;
  }

  .booking-summary-title {
    text-align: left;
    font-size: 1.5em;
  }

  .booking-preview-form {
    border: 1px solid rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 30px;

    .col-form-label {
      color: rgba(0, 0, 0, 0.5);
      text-align: left;
    }
  }
}
</style>
